import { useAppSelector } from 'core/store/hooks';
import { useMemo } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { receivedBillsByCostSelector } from '../../_redux/selectors';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'shared/utils/common.utils';
import { FatturaRicevutaDto } from '@api/client';

interface Props {
  isOpen: boolean;
  projectId: number;
  onClose: () => void;
}

const ReceivedBillsByCostModal: React.FC<Props> = ({ isOpen, projectId, onClose }) => {
  const bills = useAppSelector(receivedBillsByCostSelector);
  const { t } = useTranslation();

  // Deduplica per fkFatturaRicevuta: se la stessa fattura compare più volte
  // (perché suddivisa su più progetti) va mostrata una sola volta.
  const uniqueBills = useMemo(() => {
    const seen = new Set<string>();
    const out: FatturaRicevutaDto[] = [];
    (bills?.content || []).forEach((b) => {
      const key = b.fkFatturaRicevuta ?? '';
      if (seen.has(key)) return;
      seen.add(key);
      out.push(b);
    });
    return out;
  }, [bills]);

  return (
    <Modal show={isOpen} onHide={onClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Received bills</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '75vh', maxHeight: '75vh', overflowY: 'auto' }}>
        <Table bordered>
          <thead>
            <tr>
              <th>{t('ID')}</th>
              <th>{t('Legal Entity')}</th>
              <th>{t('Description')}</th>
              <th>{t('Supplier')}</th>
              <th>{t('Order')}</th>
              <th>{t('Date')}</th>
              <th>{t('Document Number')}</th>
              <th>{t('Taxable')}</th>
              <th>{t('Tax Amount')}</th>
            </tr>
          </thead>
          <tbody>
            {uniqueBills.map((bill) => {
              return (
                <tr key={`receivedBill-${bill.fkFatturaRicevuta}`}>
                  <td>{bill.fkFatturaRicevuta}</td>
                  <td>{bill.denominazioneAzienda}</td>
                  <td>{bill.frDescrizioneCausale}</td>
                  <td>{bill.denominazioneFornitore}</td>
                  <td>
                    {
                      bill.associatedOrders?.find(
                        (el) => el.associatedProjects?.find((pr) => pr.projectId === projectId)?.projectId === projectId
                      )?.orderId
                    }
                  </td>
                  <td>{bill.dataFattura?.toLocaleDateString('it-IT') || '-'}</td>
                  <td>{bill.frNumDocumento}</td>
                  <td className="text-end">
                    {bill.frImponibile !== undefined ? `${formatCurrency(bill.frImponibile)}€` : '-'}
                  </td>
                  <td className="text-end">
                    {bill.frImportoTotale !== undefined ? `${formatCurrency(bill.frImportoTotale)}€` : '-'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

export default ReceivedBillsByCostModal;
